import styled, { css } from 'styled-components';
import { Box, Button } from '../../atoms';
export const CustomBox = styled(Box)`
  display: flex;
  justify-content: end;
  gap: 16px;
  width: ${({
  isRow
}) => isRow ? 'auto' : '100%'};
  flex-direction: ${({
  isRow
}) => isRow ? 'row' : 'column'};
`;
export const CustomButton = styled(Button)`
  height: 48px;
  min-width: 140px;
  border-radius: 12px;
  padding: 12px 16px;
  width: ${({
  isRow
}) => isRow ? 'auto' : '100%'};
  ${({
  border
}) => !border && css`
      box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0);
    `}
`;